import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { getPortfolio } from "../../../feature/portfolio/portfolioSlice";
import AnimatedLetter from "../../AnimatedLetters";
import Loader from "../../loader/Loader";
import "./index.scss";

const Portfolio = () => {
  const portText = "Portfolio";
  const portArry = portText.split("");
  const dispatch = useDispatch();
  const { isLoding, portfolio } = useSelector((state) => state.portfolio);

  // animation
  const [letterClass, setLetterClass] = useState("text-animate");

  useEffect(() => {
    dispatch(getPortfolio());
    setTimeout(() => {
      setLetterClass("text-animate-hover");
    }, 3000);
  }, [dispatch]);

  return (
    <>
      <div className="port-container">
        <div className="port-hrader">
          <h1>
            <AnimatedLetter
              letterClass={letterClass}
              strArray={portArry}
              idx={15}
            />
          </h1>
          <p>My Work</p>
        </div>
        {isLoding ? (
          <Loader />
        ) : (
          <div className="port-main">
            <div className="port-cards">
              {portfolio.allPortfolio &&
                portfolio.allPortfolio.map((data) => {
                  const { _id, technology, title, category, image } = data;
                  return (
                    <div className="port-card" key={_id}>
                      <img src={image} alt={category} />
                      <div className="text">
                        <p className="title">
                          <span>Name:</span> {title}
                        </p>
                        <p className="category">
                          <span>Category:</span> {category}
                        </p>
                        <p className="port-technology">
                          <span>Technology:</span> {technology}
                        </p>
                      </div>
                      <Link to={_id} state={data}>
                        <Button className="port-btn" size="small">
                          View Info
                        </Button>
                      </Link>
                    </div>
                  );
                })}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Portfolio;
